export class ProcessUploadQueue {
  public static readonly type = '[UploadQueue] Process upload queue';
}
